var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayFourIsometric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.16 390.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#3a393d;}.cls-3{fill:#817e89;}.cls-4{fill:#101010;}.cls-5{fill:#050606;}.cls-6{fill:#222123;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.39,229.6C517.13,227.24,318.89,21.14,311,12.82,302.4,3.87,291.07,8,290.86,8.05c.1,0,.66-.26-9.53,2.65C270.54,13.79,267,9.91,267,9.91s-4-5.24-17.63-1.29C233.58,13.2,7.86,70.56,7.86,70.56S.77,72.38.69,79.64,0,124.4,0,124.4,195.25,375.77,202.91,385.74c6.27,8.19,22,2.49,22,2.49s284.08-103,290.7-105.42c5.81-2.48,5.39-7.66,5.39-7.66l.13-37.9S521.36,231.71,519.39,229.6Zm-97.47-57.34L238,233a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.77,12.77,0,0,1,11.55,3.2L423.76,165C426.4,167.78,425.57,171.06,421.92,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M483.26,185.58c-1.89-2-167.09-173.72-173.71-180.65-7.12-7.46-16.56-4-16.74-4,.08,0,.55-.23-7.94,2.2C275.88,5.74,273,2.5,273,2.5s-3.29-4.36-14.69-1.07C245.08,5.24,57,53,57,53s-5.91,1.52-6,7.57-.58,37.3-.58,37.3S213.14,307.39,219.52,315.69c5.22,6.83,18.36,2.08,18.36,2.08S474.61,232,480.13,229.92c4.84-2.07,4.49-6.38,4.49-6.38l.11-31.59S484.89,187.34,483.26,185.58Zm-61.34-13.32L238,233a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.77,12.77,0,0,1,11.55,3.2L423.76,165C426.4,167.78,425.57,171.06,421.92,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M480.63,182.73S316.17,11.75,309.55,4.81c-7.12-7.46-16.56-4-16.74-4,.08,0,.55-.22-7.94,2.21-9,2.57-11.91-.66-11.91-.66S269.67-2,258.27,1.31C245.08,5.12,57,52.93,57,52.93s-8.71,3-3.6,9.42C58.75,69.4,102,126,102,126s107.5,135.24,115.54,145.29,23.13,3.88,23.13,3.88,227.05-77.39,237.77-81S480.63,182.73,480.63,182.73Zm-58.71-10.47L238,233a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.77,12.77,0,0,1,11.55,3.2L423.76,165C426.4,167.78,425.57,171.06,421.92,172.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.33 281.15 242.33 308.67 475.15 224.48 475.15 201.17 242.33 281.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "475.15 201.17 458.81 206.84 475.15 224.48 475.15 201.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.67,128.13l-7.75,1.57c17.26,21.72,105.35,132.53,112.6,141.59A15.63,15.63,0,0,0,229.27,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480.63,182.73,359.56,56.84l-4.08,1.74L482.9,191.4C485.92,187.57,480.63,182.73,480.63,182.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.22,58.53c-8.48,2.19-26.72,8.67-16.64,21.56S125.51,93.35,143,88.52s132.73-36.46,143.9-39.6,25.7-9.77,12.89-21.8S269.37,18.41,255,22.2,125.69,56.33,117.22,58.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M317.63,13.22l-2-2-25.09,6.74a30.56,30.56,0,0,1,3.68,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93,70.72l-27.7,7.35,1.93,2.51L93,73.67A9.14,9.14,0,0,1,93,70.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M321.84,17.6l-1.95-2-22.27,6a30.62,30.62,0,0,1,2.44,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.83,82.62l1.92,2.5L95,78.65A17.58,17.58,0,0,1,93.69,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M304.17,27.77l21.75-5.92-1.94-2-21.6,5.86c.31.33.63.67.94,1S303.9,27.42,304.17,27.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.8,81.29,72.74,87.8l1.94,2.49L98.82,83.7c-.48-.53-.95-1.08-1.43-1.65C97.18,81.79,97,81.54,96.8,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.46,92.56l1.94,2.49,25.17-6.89c-.87-.69-1.74-1.44-2.59-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,26.1l-1.93-2-22.24,6.05A18.26,18.26,0,0,1,307,32.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79.66,96.8l2,2.48,27.69-7.54a30.71,30.71,0,0,1-3.51-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.81,37.37,334,30.21l-1.93-2-24.32,6.61A8.49,8.49,0,0,1,307.81,37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M429.86,165.28,330.26,59.9a16.45,16.45,0,0,0-14.85-4.11l-183.54,51.5c-4.77,1.34-6.13,5.59-3,9.44l94.32,117.15a14,14,0,0,0,14.18,4.17l190.16-63.39C432.2,173.1,433.26,168.87,429.86,165.28Zm-7.94,7L238,233a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.77,12.77,0,0,1,11.55,3.2L423.76,165C426.4,167.78,425.57,171.06,421.92,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.69,217.59c-3.12-1.08-3.11-2.79,0-3.82l22.31-7.3c3.14-1,5.27.8,4.75,4.06l-1.55,9.58a4.91,4.91,0,0,1-6.64,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayFourIsometric);
export default __webpack_public_path__ + "static/media/gray-four-isometric.c3fffec3951096faf0ac333303a38c89.svg";
export { ForwardRef as ReactComponent };